import axios from "axios";
import useStorage from "hooks/useStorage";

const timeout = process.env.REACT_APP_DEFAULT_TIMEOUT;

export const clientState = {
  requesting: false,
};

const handleCatchError = (error) => {
  const { setItem, getItem, removeItem, clear } = useStorage();

  let result = {};

  if (error.code === "ECONNABORTED") {
    result = {
      status: error?.response?.status,
      error: { code: "E_REQUEST_TIMOUT", message: `Request Timeout for ${timeout} ms` },
    };
  } else if (error.code === "ERR_NETWORK") {
    result = {
      status: error?.status,
      error,
    };
  } else {
    if (error?.response?.status === 401) {
      const onInstruction = getItem("savedTimerInstruction");
      const participant = getItem("participant");
      const onExam = getItem("exam");

      if (onInstruction || onExam) {
        setItem("lastParticipant", participant);
        removeItem("_grecaptcha");
        removeItem("token");
      } else {
        clear();
      }
      removeItem("isLogin");

      const queryParams = new URLSearchParams(window.location.search);
      const accessToken = queryParams.get(process.env.REACT_APP_ACCESS_TOKEN_KEY);

      if (accessToken) {
        const redir = new URL(window.location.pathname, window.location.origin);
        window.location.replace(redir);
      } else {
        window.location.reload();
      }
    }
    result = { status: error?.response?.status, error: error?.response?.data };
  }
  return result;
};

const requestAPI = async ({
  method = "GET",
  endpoint,
  data,
  headers,
  otherConfig,
  isAuth = false,
  isToken = true,
  isSubmit = false,
  pToken = null,
}) => {
  const { getItem } = useStorage();

  let result = {};
  let host = isAuth ? process.env.REACT_APP_AUTH_SERVICE : process.env.REACT_APP_EXEC_SERVICE;
  host = isSubmit ? process.env.REACT_APP_SUBMISSION_SERVICE : host;
  const url = `${host}${endpoint}`;
  const token = pToken || getItem("token");
  let optHeaders = {
    ...headers,
    "Access-Control-Allow-Origin": "*",
  };
  if (isToken) optHeaders = { ...optHeaders, Authorization: `Bearer ${token}` };
  const reqConfig = { url, method, timeout, headers: optHeaders, data, ...otherConfig };
  if (!endpoint) throw new Error("url parameter is required");

  clientState.requesting = true;

  try {
    const apiResponse = await new Promise((resolve, reject) => {
      try {
        const res = axios.request(reqConfig);
        resolve(res);
      } catch (error) {
        reject(new Error(`An error occurred: ${error.message || error}`));
      }
    });
    result = apiResponse.data;
    clientState.requesting = false;
    return result;
  } catch (error) {
    clientState.requesting = false;
    return handleCatchError(error);
  }
};

export default {
  requestAPI,
};
